import { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaLongArrowAltLeft } from "react-icons/fa";
import PreGameUI from "../components/preGameUI/PreGameUI";
import { Loader } from "../components/loader/Loader";
import { AppLayout } from "../layout/AppLayout";
import Button from "../components/button/Button";
import { useGenerateCampaignGame } from "../api/useGenerateCampaignGame";
import { extractIdsFromPath, extractIdsFromUrl } from "../utils";
import { UserContext } from "../components/context/UseContext";
import clsx from "clsx";
import { useGetSpinTheWheel } from "../api/getSpinthewheel";
import { AnimatePresence } from "framer-motion";
import { FullModal } from "../modules/world/rmc/modals/fullModal";
import { useArenaDeductFee } from "../api/arenaDeductFee";
import { useGetTrialCheck } from "../api/campaigns/getTrialCheck";

function PreGame() {
  const navigate = useNavigate();
  const location = useLocation();
  const { generateCampaignGame, data, loading } = useGenerateCampaignGame();
  const hashedData = localStorage.getItem("arena_hashed_d");
  const { profile, token } = useContext(UserContext);
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("userId");
  const hasFetched = useRef(false);

  const values = extractIdsFromUrl(location.search);
  const hash = extractIdsFromPath(location.pathname);

  const {
    handelDeductFee,
    isLoading: isDeducting,
    insufficient,
    setInsufficient,
    show,
    setShow,
  } = useArenaDeductFee();

  const {
    loading: spinning,
    getSpinTheWheel,
    data: spinData,
  } = useGetSpinTheWheel();

  const { loading: spins, getTrialCheck, data: spinDa } = useGetTrialCheck();

  useEffect(() => {
    if (hasFetched.current) return;
    const expires = searchParams.get("expires");
    const signature = searchParams.get("signature");
    if (expires && signature && userId) {
      hasFetched.current = true;
      generateCampaignGame({
        token: token,
        campaign_id: hash?.campaign_id,
        game_id: hash?.game_id,
        user_id: userId ?? profile.id,
        is_link: true,
        route: `?data=${hashedData}&expires=${expires}&signature=${signature}`,
      });
    } else if (hash && !expires && !signature) {
      hasFetched.current = true;
      generateCampaignGame({
        token: token,
        campaign_id: hash.campaign_id,
        game_id: hash.game_id,
        is_link: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location,
    values?.campaignId,
    values?.gameId,
    hash?.campaign_id,
    hash?.game_id,
  ]);

  useEffect(() => {
    if (spinData?.data && data?.data?.game) {
      if (!spinData?.data?.spin_the_wheel_participation_details[0]?.is_free) {
        if (spinDa?.data?.user_trial_used === spinDa?.data?.no_of_free_trials) {
          setShow(true);
        } else {
          navigate(
            `/game-started?slug=${data?.data?.game.slug?.toLowerCase()}&id=${
              data?.data?.game?.spin_the_wheels[0]?.id
            }`,
          );
        }
      } else {
        navigate(
          `/game-started?slug=${data?.data?.game.slug?.toLowerCase()}&id=${
            data?.data?.game?.spin_the_wheels[0]?.id
          }`,
        );
      }
    }
  }, [spinData?.data, spinDa?.data, data?.data?.game, navigate, setShow]);

  return (
    <AppLayout bg={clsx("h-svh overflow-auto hidden-scrollbar")}>
      <div className="relative ">
        <div
          className="relative min-h-screen bg-no-repeat bg-cover bg-bottom pb-14 custom-gradients" // REDUCED BUTTOM PADDING HERE FROM 32
          // style={{ backgroundImage: `url('../../../image/pregamebg.png')` }}
        >
          {loading ? (
            <div className="h-[70dvh] flex items-center justify-center">
              <Loader type="spinningBubbles" color="#fff" />
            </div>
          ) : data ? (
            <>
              <div className="relative pt-5 pb-5">
                <div className="relative h-5 w-full block">
                  <p
                    onClick={() =>
                      navigate(`/campaign_id/${data?.data?.campaign_id}`)
                    }
                    className="absolute cursor-pointer left-5 flex items-center gap-2 font-medium text-white"
                  >
                    <FaLongArrowAltLeft className="text-lg" /> Back
                  </p>
                </div>
                <h3
                  className="text-3xl mt-4 font-extrabold text-white text-center mx-auto max-w-[260px] leading-tight uppercase"
                  style={{
                    textShadow: "3px 3px 0 #003399",
                  }}
                >
                  {data?.data?.game.name ?? ""}
                </h3>
              </div>
              <div className="container pb-12">
                {
                  <PreGameUI
                    loading={spinning || spins}
                    onclick={(val) => {
                      if (data?.data?.game.type === "trivias") {
                        if (data?.data?.game?.trivias?.length > 0) {
                          if (data?.data?.game?.trivias[0]?.entry_fee > 0) {
                            setShow(true);
                          } else {
                            const navigateUrl = `/game-started?slug=${data?.data?.game.slug?.toLowerCase()}&id=${
                              data?.data?.game?.trivias[0]?.id
                            }&game_id=${data?.data?.game?.trivias[0]?.game_id}`;
                            sessionStorage.removeItem("claimedActive");
                            sessionStorage.removeItem("spinGameActive");

                            navigate(navigateUrl);
                          }
                        }

                        // navigate(
                        //   `/game-started?slug=${data?.data?.game.slug?.toLowerCase()}&id=${
                        //     data?.data?.game.type === "trivias"
                        //       ? data?.data?.game?.trivias[0]?.id
                        //       : data?.data?.game?.spin_the_wheels[0]?.id
                        //   }`
                        // );
                      } else if (data?.data?.game.type === "recalls") {
                        const navigateUrl = `/game-started?slug=${data?.data?.game.slug?.toLowerCase()}&id=${
                          data?.data?.game?.recalls[0]?.id
                        }&game_id=${data?.data?.game?.recalls[0]?.game_id}`;
                        sessionStorage.removeItem("claimedActive");
                        sessionStorage.removeItem("spinGameActive");

                        navigate(navigateUrl);
                      } else {
                        getTrialCheck(val);
                        getSpinTheWheel(val);
                      }
                    }}
                    game={data?.data?.game}
                  />
                }
              </div>
              {data?.data?.campaign?.brand?.image_url && (
                <div className="container mt-5 pb-4">
                  <div className="flex justify-center items-center gap-2">
                    <p className="text-white/60 text-base font-medium">
                      Sponsored by
                    </p>
                    <img
                      src={data?.data?.campaign?.brand?.image_url}
                      alt={data?.data?.campaign?.brand?.name || "Sponsor"}
                      className="h-7 w-7 rounded-full object-cover"
                    />
                  </div>
                </div>
              )}
            </>
          ) : (
            !loading && (
              <div className="flex flex-col h-[70dvh] justify-center">
                <h3
                  className="text-4xl mt-4 font-extrabold text-white text-center mx-auto max-w-[260px] leading-tight"
                  style={{
                    textShadow: "3px 3px 0 #003399",
                  }}
                >
                  This Link has expired
                </h3>
                <div className="mt-10 px-10">
                  <Button
                    onClick={() => {
                      navigate(`/home`);
                    }}
                    text="Back to Home"
                  />
                </div>
              </div>
            )
          )}
        </div>
      </div>
      <AnimatePresence>
        {show && (
          <FullModal
            className={clsx(
              "h-[508px] fixed inset-x-0 bottom-0 z-[4000] bg-[#fff] animate-slide-up 480:max-w-[440px] 480:mx-auto rounded-t-[20px]",
            )}
            onClose={() => setShow(false)}
            showCloseIcon
            iconClass={"!text-[#000]"}
          >
            <div className="px-5 pt-16 flex flex-col items-center">
              <Wallet />
              <p className="my-2 text-center text-xl font-bold text-black">
                Confirm Entry Fee
              </p>
              <p className="font-medium text-center text-[#000]">
                You are about to be charged
              </p>
              <div className="mt-7">
                <p className="font-bold text-3xl text-center text-[#2741d6]">
                  ₦
                  {(data?.data?.game?.trivias
                    ? data?.data?.game?.trivias[0]?.entry_fee
                    : spinData?.data?.spin_the_wheel_participation_details[0]
                        ?.entry_fee) ?? 0}
                </p>
                <p className="font-medium text-[#000] text-center">
                  from your main wallet
                </p>
              </div>
              <div className="w-full flex flex-col gap-5 mt-10">
                <Button
                  onClick={() => {
                    if (data?.data?.game.type === "trivias") {
                      const params = {
                        id: data?.data?.game?.trivias[0]?.id,
                        slug: data?.data?.game.slug?.toLowerCase(),
                        fee: data?.data?.game?.trivias[0]?.entry_fee,
                      };
                      handelDeductFee(params.id, params.slug, params.fee);
                    } else {
                      const params = {
                        id: data?.data?.game?.spin_the_wheels[0]?.id,
                        slug: data?.data?.game.slug?.toLowerCase(),
                        fee: spinData?.data
                          ?.spin_the_wheel_participation_details[0]?.entry_fee,
                      };
                      handelDeductFee(params.id, params.slug, params.fee);
                    }
                  }}
                  text={
                    isDeducting ? <Loader type="bubbles" /> : "Proceed to Game"
                  }
                  className={isDeducting ? "!py-1" : "text-lg py-[18px]"}
                />
                <Button
                  onClick={() => setShow(false)}
                  text="Cancel"
                  className="text-lg py-[18px] !bg-[#1A1F33] !text-[#FFFFFFBF]"
                />
              </div>
            </div>
          </FullModal>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {insufficient && (
          <FullModal
            className={clsx(
              "h-[432px] fixed inset-x-0 bottom-0 z-[4000] bg-[#111522] animate-slide-up 480:max-w-[440px] 480:mx-auto rounded-t-[20px]",
            )}
            onClose={() => setInsufficient(false)}
            showCloseIcon
          >
            <div className="px-5 pt-16 flex flex-col items-center">
              <InsufficientWallet />
              <p className="my-2 text-center text-xl font-bold text-white">
                Insufficient Funds
              </p>
              <p className="font-medium text-center text-[#FFFFFF80]">
                Oh no! It looks like your wallet is a bit light. Please add
                funds to continue your Arena XP journey.
              </p>

              <div className="w-full flex flex-col gap-5 mt-10">
                <Button
                  onClick={() => {
                    navigate(`/settings/wallet/fund/card-topup`);
                  }}
                  text={
                    <div className="flex justify-center items-center gap-2.5">
                      <WalletPlus />
                      <p className="text-white text-base font-medium ">
                        Fund Wallet
                      </p>
                    </div>
                  }
                  className={"text-lg py-[18px] !bg-[#E92932]"}
                />
                <Button
                  onClick={() => setInsufficient(false)}
                  text="Cancel"
                  className="text-lg py-[18px] !bg-[#1A1F33] !text-[#FFFFFFBF]"
                />
              </div>
            </div>
          </FullModal>
        )}
      </AnimatePresence>
    </AppLayout>
  );
}

export default PreGame;

const Wallet = () => {
  return (
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="58" height="58" rx="29" fill="#2741d6" />
      <path
        d="M37 25V21.5C37 21.1022 36.842 20.7206 36.5607 20.4393C36.2794 20.158 35.8978 20 35.5 20H22C21.6022 20 21.2206 20.158 20.9393 20.4393C20.658 20.7206 20.5 21.1022 20.5 21.5V36.5C20.5 36.8978 20.658 37.2794 20.9393 37.5607C21.2206 37.842 21.6022 38 22 38H35.5C35.8978 38 36.2794 37.842 36.5607 37.5607C36.842 37.2794 37 36.8978 37 36.5V33"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M37 25H30C29.1716 25 28.5 25.6716 28.5 26.5V31.5C28.5 32.3284 29.1716 33 30 33H37C37.8284 33 38.5 32.3284 38.5 31.5V26.5C38.5 25.6716 37.8284 25 37 25Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 29C31.5 28.4477 31.9477 28 32.5 28C33.0523 28 33.5 28.4477 33.5 29C33.5 29.5523 33.0523 30 32.5 30C31.9477 30 31.5 29.5523 31.5 29Z"
        fill="white"
      />
    </svg>
  );
};

const InsufficientWallet = () => {
  return (
    <svg
      width="73"
      height="57"
      viewBox="0 0 73 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.8326 13.8889V7.66667C49.8326 6.95942 49.5517 6.28115 49.0516 5.78105C48.5515 5.28095 47.8733 5 47.166 5H23.1666C22.4594 5 21.7811 5.28095 21.281 5.78105C20.7809 6.28115 20.5 6.95942 20.5 7.66667V34.3333C20.5 35.0406 20.7809 35.7189 21.281 36.219C21.7811 36.719 22.4594 37 23.1666 37H47.166C47.8733 37 48.5515 36.719 49.0516 36.219C49.5517 35.7189 49.8326 35.0406 49.8326 34.3333V28.1111"
        stroke="#E92932"
        stroke-width="3"
        stroke-linejoin="round"
      />
      <path
        d="M49.8334 13.8892H37.3893C35.9165 13.8892 34.7227 15.0831 34.7227 16.5558V25.4447C34.7227 26.9175 35.9165 28.1114 37.3893 28.1114H49.8334C51.3061 28.1114 52.5 26.9175 52.5 25.4447V16.5558C52.5 15.0831 51.3061 13.8892 49.8334 13.8892Z"
        stroke="#E92932"
        stroke-width="3"
        stroke-linejoin="round"
      />
      <path
        d="M42.1094 21C42.1094 20.8467 41.9852 20.7219 41.832 20.7217C41.6787 20.7217 41.5537 20.8466 41.5537 21C41.5539 21.1532 41.6788 21.2773 41.832 21.2773C41.9851 21.2771 42.1091 21.1531 42.1094 21Z"
        fill="#E92932"
        stroke="#E92932"
        stroke-width="3"
      />
    </svg>
  );
};

const WalletPlus = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H14V18H4V12H22V6C22 4.89 21.11 4 20 4ZM20 8H4V6H20V8ZM24 17V19H21V22H19V19H16V17H19V14H21V17H24Z"
        fill="white"
      />
    </svg>
  );
};
